/* eslint-disable react/no-array-index-key */

import React, { useEffect, useState } from 'react'

import { useNavigate } from 'react-router-dom'
import { useWindowSize } from 'react-use'

import { NewVenues } from '@kolayyolla/common/services/venueService'

import { CardMedia, Container, Grid, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    height: 320,
    position: 'relative',
    margin: theme.spacing(3),
    borderRadius: '0.6rem'

  },
  container: {
    margin: theme.spacing(3, 0, 3, 0)
  },

  header: {
    fontWeight: 'bold'
  },

  media: {

    overflow: 'hidden',
    transition: '300ms',
    cursor: 'pointer',
    position: 'relative',
    top: 0,
    left: 0,
    borderRadius: '0.6rem',
    width: '100%',
    height: '100%',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',

    '&:hover': {
      filter: 'brightness(115%)'
    }
  },

  layer: {
    height: '100%',
    width: '100%',
    background: 'linear-gradient(0deg, rgba(0, 0, 0, 0.9) 0%, rgba(0, 0, 0, 0.05) 50%, rgba(0, 0, 0, 0.05) 85%)'

  },
  column: {
    minHeight: 300
  },
  mediaCaption: {
    textOverflow: 'ellipsis',
    position: 'absolute',
    bottom: 0,
    padding: 15,
    color: 'white',
    width: '100%',
    fontSize: 15,
    fontWeight: 500,
    transition: '300ms',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      height: 100
    },

    '& .logo': {
      borderRadius: '50%',
      width: theme.spacing(4),
      height: theme.spacing(4),
      marginRight: theme.spacing(1)
    }

  },

  bannerGrid:
  {
    height: '100%',
    position: 'relative'

  }

}))

const NewVenuesBanner = () => {
  const classes                = useStyles()
  const [items, setItems]      = useState([])
  const [venues, setVenues]    = useState([])
  const { width: windowWidth } = useWindowSize()

  useEffect(() => {
    let isMounted = true

    NewVenues({ limit: 4 }).then((data) => {
      if (isMounted) {
        setVenues(data.sort(() => 0.5 - Math.random()).slice(0, 4))
      }
    })

    return () => {
      isMounted = false
    }
  }, [venues.length])

  useEffect(() => {
    if (venues.length > 1) setItems(chunk(venues, windowWidth > 1200 ? 4 : windowWidth > 900 ? 3 : windowWidth > 6500 ? 2 : 1))
  }, [windowWidth, venues])

  const chunk = (arr, size) => Array.from({ length: Math.ceil(arr.length / size) }, (v, i) => arr.slice(i * size, i * size + size))

  return (
    <div className={classes.container}>
      <Typography variant="h3" align="center" className={classes.header}>En Yeniler</Typography>
        {
          items.map((row, index) => {
            return <Banner row={row} key={index} />
          })
        }
    </div>
  )
}

function Banner ({ row }) {
  const classes  = useStyles()
  const navigate = useNavigate()

  const items = row.map((item) => (<Grid item xs={12 / row.length} key={item.resId} className={classes.column}>
      <CardMedia
        className={classes.media}
        image={item?.heroImage?.lg}
        title={item.name}
        onClick={() => navigate(`/${item.alias}`)}
      >
        <div className={classes.layer} />
        <Typography className={classes.mediaCaption}>
          <img alt={item.name} src={item?.logo?.md} className="logo" />
          {`${item.name} - (${item?.areaDetails?.district.replace(' Mahallesi', '')})`}
        </Typography>
      </CardMedia>

    </Grid>
  ))

  return (
    <Container>
      <Grid container spacing={4} className={classes.bannerGrid}>
        {items}
      </Grid>
    </Container>
  )
}

export default NewVenuesBanner
